// extracted by mini-css-extract-plugin
module.exports = {"btnDangerWrapper":"CustomerTags_btnDangerWrapper__o7yuU"};